//Componentes Generales
import React, { useContext } from "react";
import agregarReqContext from "../../context/agregarReq/agregarReqContext";
import authContext from "../../context/authentication/authContex";
import FormReq from "../../components/FormReq/FormReq";

// Alertas
import Swal from "sweetalert2";

//Estilos
import "./AddReq.css";

/* 
    Vista donde se gestiona toda la lógica para añadir un requerimiento.
        Donde reqEdit no esta en uso.
              cerrar no esta en uso.
*/
function AddReq({ reqEdit, cerrar }) {
  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuario: user } = aContext;

  //Context agregar requerimiento
  const addContext = useContext(agregarReqContext);
  const { req, guardarRequerimiento, itemsList } = addContext;

  /* 
        Función encargada de validar los campos de un requerimiento a guardar.
            Donde r es el requerimiento.
                  i son los items del requerimiento.
        Retorna una respuesta.
    */
  const validacionesCampos = (r, i) => {

    if (r.title === "") {
      return "Falta ingresar titulo de requerimiento";
    } else if (r.deliveryDate == null) {
      return "Falta ingresar la fecha de entrega del requerimiento";
    } else if (r.fchMov == null) {
      return "Falta ingresar la fecha de movimiento del requerimiento";
    } else if (r.tDocAbmReqSectorCodsem === "") {
      return "Falta ingresar el sector de requerimiento";
    } else {
      if (i.length === 0) {
        return "Ingrese por lo menos un item";
      } else {
        for (const element of i) {
          if (element.quantity === 0) {
            return "Existe un item sin cantidad asignada";
          }
          if (!element.tipoCosto) {
            return "Debe seleccionar un tipo de costo para cada item";
          }
          const tieneCentroCosto =
            element.centroCostoDistribucion?.distribucion ||
            (element.centroCostoDistribucion?.subcuentas?.length > 0) ||
            (element.centroCosto && element.centroCosto.abmSubCue);
          if (!tieneCentroCosto) {
            return "Debe seleccionar un centro de costo para cada item";
          }
        }
      }
    }
    return "";
  };

  /* 
        Función encargada de guardar el requerimiento.
            Donde requeriment es el requerimiento a guardar.
                  items son los items del requerimiento.
                  files son los arhivos adjuntos.
    */
  const handleSaveReq = async (requeriment, items, files, accountingProration = [], clientProration = []) => {
    const msj = validacionesCampos(requeriment, items);

    if (requeriment !== undefined && requeriment !== null) {
      if (msj === "") {
        const resp = await guardarRequerimiento(
          requeriment,
          items,
          user,
          files,
          accountingProration,
          clientProration
        );
        Swal.fire({
          title: `Se guardo un nuevo requerimiento`,
          icon: "success",
          text: `El numero de requerimiento es : ${resp.tDocNroFor}`,
          showConfirmButton: true,
          allowEnterKey: true,
        });
        return true;
      } else {
        Swal.fire({
          title: msj,
          icon: "warning",
          showConfirmButton: true,
          allowEnterKey: true,
        });
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <div className="container-list">
      <FormReq
        req={reqEdit ? reqEdit : req}
        itemList={itemsList}
        guardarReq={handleSaveReq}
        cerrar={cerrar}
      />
    </div>
  );
}

export default AddReq;